/**
 * Products API endpoints — T20.
 * Maps PRD §9.3 to typed fetch calls via apiClient.
 */
import {
  type CreateProductRequest,
  ListProductsResponseSchema,
  ProductResponseSchema,
  type UpdateProductRequest,
} from '@malaberg/shared';
import { apiClient } from '../client';

export interface ListProductsQuery {
  limit?: number;
  offset?: number;
}

function toQueryString(params: Record<string, string | number | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined);
  if (entries.length === 0) return '';
  return `?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
}

export const productsApi = {
  list(query: ListProductsQuery = {}) {
    return apiClient.request(
      'GET',
      `/api/products${toQueryString(query as Record<string, string | number | undefined>)}`,
      {
        schema: ListProductsResponseSchema,
      }
    );
  },

  getVersions(id: string) {
    return apiClient.request('GET', `/api/products/${id}/versions`);
  },

  getVersion(id: string, version: number) {
    return apiClient.request('GET', `/api/products/${id}/versions/${version}`, {
      schema: ProductResponseSchema,
    });
  },

  create(body: CreateProductRequest) {
    return apiClient.request('POST', '/api/products', {
      body: JSON.stringify(body),
    });
  },

  update(id: string, body: UpdateProductRequest) {
    return apiClient.request('PUT', `/api/products/${id}`, {
      body: JSON.stringify(body),
    });
  },

  revert(id: string, version: number) {
    return apiClient.request('POST', `/api/products/${id}/revert/${version}`, {
      body: JSON.stringify({}),
    });
  },

  delete(id: string) {
    return apiClient.request('DELETE', `/api/products/${id}`);
  },
};
